import { slideToggle } from '@pc/components/Slide'

function toggle(button: HTMLElement, list: HTMLElement) {
  const iconNode = button.querySelector<HTMLElement>('.js-toggle-icon')
  const textNode = button.querySelector<HTMLElement>('.js-toggle-text')
  const openIcon = 'icon-plus-o'
  const closeIcon = 'icon-minus-o'

  if (textNode === null || iconNode === null) return

  if (iconNode.classList.contains(openIcon)) {
    iconNode.classList.remove(openIcon)
    iconNode.classList.add(closeIcon)
    textNode.innerText = '閉じる'
  } else {
    iconNode.classList.remove(closeIcon)
    iconNode.classList.add(openIcon)
    textNode.innerText = 'すべて表示する'
  }

  slideToggle({ el: list })
}

export function listRelatedLink() {
  const wrapper = [].slice.call(document.getElementsByClassName('js-works-list-link'))
  if (wrapper.length === 0) return

  wrapper.forEach((el: HTMLElement) => {
    const button = el.querySelector<HTMLElement>('.js-search-toggle-launcher')
    const list = el.querySelector<HTMLElement>('.js-search-toggle-list')
    if (button === null || list === null) return

    button.addEventListener('click', (e) => {
      toggle(e.currentTarget as HTMLElement, list)
    })
  })
}
